module.exports = __webpack_public_path__ + "static/img/动态合规策略匹配.792646d2.png";